const tokenName = 'token';
const tokenNameSLNI = 'tokenSLNI';
const expirationDate = "expirationDate"

export const setToken = token => localStorage.setItem(tokenName, token);
export const getToken = () => localStorage.getItem(tokenName);

export const setExpirationDate =  date => localStorage.setItem(expirationDate, date)
export const getExpirationDate = () => localStorage.getItem(expirationDate)

export const setTokenSLNI = token => localStorage.setItem(tokenNameSLNI, token);
export const getTokenSLNI = () => localStorage.getItem(tokenNameSLNI);